// utils/currency.js

export function getCurrencySymbol(code) {
  switch (code) {
    case "EUR":
      return "€";
    case "USD":
      return "$";
    case "GBP":
      return "£";
    default:
      return code + " "; // fallback to currency code
  }
}

export function formatCurrency(amount, currency = "EUR") {
  // Default/fallback if currency is not a valid ISO code
  if (typeof currency !== "string" || currency.length !== 3) currency = "EUR";
  if (amount == null) return "—";
  return amount.toLocaleString("en-IE", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
